import React, { useState } from "react";

import { Button } from "bootstrap-micro";

const MODE_ICONS = {
    "MODE_ENABLED": "icon-tick-circled",
    "MODE_INPUT_DISABLED": "icon-event-warn",
    "MODE_OUTPUT_DISABLED": "icon-event-warn",
    "MODE_BOTH_DISABLED": "icon-cross",
    "MODE_TEST_INPUT": "icon-spanner",
    "MODE_TEST_INPUT_OUTPUT": "icon-spanner"
}

import {  useModuleDevicesGroupedByZoneFromRouter } from "../../store/panelsSlice.js";
import { useRouteMatch } from "react-router-dom";

import { lookupDeviceName } from "../../const.js";

function ModeIcon(props) {
    return <span className={MODE_ICONS[props.value]}></span>
}


export const DevicesTab = () =>
{
    const match = useRouteMatch();
    const [filter, setFilter] = useState("");
    const [showEmpty, setShowEmpty] = useState(false);


    const devicesByZone = useModuleDevicesGroupedByZoneFromRouter(showEmpty, filter);

    const devicesFound = devicesByZone.find( zone => zone.devices.length > 0) !== null;

    return <div>
        <div className="row">
            <div className="col-sm-6 col-sm-offset-3">
                <div className="input-group" style={{ marginBottom: "10px" }}>
                    <input className="form-control" type="text" id="device-filter" value={filter} onChange={ev => setFilter(ev.target.value) } placeholder="Filter devices" />
                    <span className="input-group-btn">
                        <Button onClick={() => setFilter("") }>&times;</Button>
                    </span>
                </div>
            </div>
            <div className="col-sm-3">
                <Button onClick={() => setShowEmpty(!showEmpty) }>{showEmpty ? "Hide" : "Show"} Empty Zones</Button>
            </div>
        </div>
        <table className="table table-striped">
            {
                devicesByZone.map( zone => (
                    <tbody key={"z-" + zone.id}>
                        <tr key={"z-" + zone.id}>
                            <td><ModeIcon value={zone.mode} /></td>
                            <th colSpan={2}>{zone.name}</th>
                            <td><a href={`#${match.url}/zone/${zone.id}`}><span className="icon-pencil-edit"></span></a></td>
                        </tr>
                        {zone.devices.map(d => <tr key={"d-" + d.id}>
                            <td><ModeIcon value={d.settings.mode} /></td>
                            <td>{d.name}</td>
                            {/* <td>{d.type}</td> */}

                            <td>{lookupDeviceName(d.type)}</td>
                            <td><a href={`#/site/${match.params.hwaddr}/panel/${match.params.networkId}/modules/${d.port_id}/device/${d.mod_idx}`}><span className="icon-pencil-edit"></span></a></td></tr>)}
                    </tbody>
                ))
            }
        </table>
        <hr />
        {
            !devicesFound
                ?
                (
                    <div className="text-center row">
                        <div className="col-sm-6 col-sm-offset-3 alert alert-info" role="alert" >
                            <p>No Devices found.</p>
                        </div>
                    </div>
                )
                :
                null
        }

    </div >
}